class SiteElementOrderStatus
    extends QueryElement<HTMLElement> {
    
    private readonly _site: Site;
    
    constructor(element: HTMLElement, site: Site) {
        super(element);
        
        this._site = site;
        this.reload();
    }

    getSite() {
        return this._site;
    }

    async reload() {
        let request = new QueryRequest('/Assortment/OrderStatus', {
            contentType: 'json',
            method: 'get'
        });

        let response = await request.request();
        let jsonResponse = await response.text();

        this.setHtml(jsonResponse);
    }
}